import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  updateConfigs,
  getConfigs,
  modifyConfigs,
  loadClientsList,
  setClient,
  setBuilding,
  setFloor,
  setRoom,
  clearRoom,
} from "../../../actions/adminAction";
import { setAlert } from "../../../actions/alertAction";
import Alert from "../../../layouts/Alert";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

function TriggerDescTooltip({ content }) {
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props} variant="primary">
      {content}
    </Tooltip>
  );

  return (
    <OverlayTrigger
      placement="right"
      delay={{ show: 250, hide: 400 }}
      overlay={renderTooltip}
    >
      <span>ℹ</span>
    </OverlayTrigger>
  );
}

const ConfigsForm = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const {
    clientsList,
    client,
    building,
    floor,
    room,
    clientListLoading,
    configs,
    configsLoading,
    configModified,
  } = useSelector((state) => state.admin);
  const [buildingList, setBuildingList] = useState([]);
  const [floorList, setFloorList] = useState([]);
  const [roomList, setRoomList] = useState([]);
  const dark = useSelector((state) => state.dark.data);
  const dashboard = useSelector((state) => state.dashboard.data);

  const [formData, setFormData] = useState({
    client_id: undefined,
    building_id: undefined,
    floor_id: undefined,
    room_id: undefined,
  });

  const [isSelect, setIsSelect] = useState(false);

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.id]: parseInt(e.target.value, 10) });

    //Populate selected dropdown
    if (e.target.id === "client_id") {
      const buildings = dashboard?.filter(
        (item) => item.client_id === parseInt(e.target.value)
      );
      dispatch(setClient({ client_id: parseInt(e.target.value, 10) }));
      setBuildingList(buildings);
    } else if (e.target.id === "building_id") {
      const selectedBuilding = buildingList?.find(
        (item) => item.id === parseInt(e.target.value)
      );
      const floors = selectedBuilding ? selectedBuilding.floors : [];
      dispatch(setBuilding({ building_id: parseInt(e.target.value, 10) }));
      setFloorList(floors);
    } else if (e.target.id === "floor_id") {
      const selectedFloor = floorList?.find(
        (item) => (item) => item.id === parseInt(e.target.value)
      );
      const rooms = selectedFloor ? selectedFloor.rooms : [];
      dispatch(setFloor({ floor_id: parseInt(e.target.value, 10) }));
      setRoomList(rooms);
    } else if (e.target.id === "room_id") {
      dispatch(setRoom({ room_id: parseInt(e.target.value, 10) }));
    }
    dispatch(modifyConfigs(true));
  };

  const onSubmit = (e) => {
    dispatch(updateConfigs(formData));
    dispatch(modifyConfigs(false));
    e.preventDefault();
  };

  const onSelectDeselect = () => {
    setIsSelect(!isSelect);
    if (isSelect && formData) {
      setFormData({
        ...formData,
        config: {
          ...Object.fromEntries(
            Object.entries(formData.config).map(([key, value]) => [
              key,
              { ...value, activate: false },
            ])
          ),
        },
      });
    } else {
      setFormData({
        ...formData,
        config: {
          ...Object.fromEntries(
            Object.entries(formData.config).map(([key, value]) => [
              key,
              { ...value, activate: true },
            ])
          ),
        },
      });
    }
    dispatch(modifyConfigs(true));
  };

  // Load Client list on initial load
  useEffect(() => {
    if (user.client_id === null) {
      if (clientListLoading) {
        dispatch(loadClientsList());
      }
    }
  }, [clientsList]);

  // When all the filter selected get the config
  useEffect(() => {
    if (client && building && floor && room) {
      const queryObj = {
        client,
        building,
        floor,
        room,
      };
      dispatch(getConfigs(queryObj));
    }
  }, [client, building, floor, room]);

  // When configs data available, set form data
  useEffect(() => {
    if (configs) {
      setFormData({ ...formData, config: configs.config });
    } else {
      setFormData({});
    }
  }, [configs]);

  // UseEffect-Logic 2
  // useEffect(() => {
  //   if (user.client_id !== null) {
  //     if (configsLoading) {
  //       dispatch(getConfigs());
  //     }
  //   } else {
  //     if (configsLoading) {
  //       dispatch(getConfigs(user.client_id));
  //     }
  //   }
  // }, [configs, configsLoading]);

  // useEffect(() => {
  //   if (formData.client_id) {
  //     dispatch(getConfigs(formData.client_id));
  //   }
  // }, [formData.client_id]);

  return (
    <div className="admin-card px-sm-5 py-sm-4 p-2 me-0 mt-0 mb-0 text-main">
      <div className="mb-2 ">
        <div className="d-flex align-items-center">
          <h6 className="text-main mb-0">Admin / Alert Configurations</h6>{" "}
        </div>
        <div className="d-flex w-100 my-2 align-items-center justify-content-between">
          <h4 className="m-0">Alert Configurations</h4>
        </div>
      </div>

      <form
        className="card w-100 p-2 p-sm-3 p-lg-4 shadow-lg border-0 admin-list mb-2 h-max-content"
        onSubmit={(e) => onSubmit(e)}
      >
        <Alert />
        {/* Selection Form */}
        <div className="row">
          <div className="col-lg-4 col">
            <div className="mb-3">
              <h5 className="text-main fw-bold">Company</h5>
              <select
                name="client_id"
                id="client_id"
                className="form-select admin-list"
                style={{
                  background: `#272a3d url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='${
                    dark ? "white" : ""
                  }' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right .75rem center/8px 10px`,
                }}
                onChange={(e) => onChange(e)}
                value={formData.client_id}
              >
                <option value={null}>Select Company</option>
                {clientsList?.map((client) => (
                  <option value={client.id}>{client.title}</option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-4 col">
            <div className="mb-3">
              <h5 className="text-main fw-bold">Building</h5>
              <select
                name="building_id"
                id="building_id"
                className="form-select admin-list"
                style={{
                  background: `#272a3d url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='${
                    dark ? "white" : ""
                  }' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right .75rem center/8px 10px`,
                }}
                onChange={(e) => onChange(e)}
                value={formData.building_id}
              >
                <option value={null}>Select Building</option>
                {buildingList?.map((item) => (
                  <option value={item.id}>{item.name}</option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-4 col">
            <div className="mb-3">
              <h5 className="text-main fw-bold">Floors</h5>
              <select
                name="floor_id"
                id="floor_id"
                className="form-select admin-list"
                style={{
                  background: `#272a3d url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='${
                    dark ? "white" : ""
                  }' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right .75rem center/8px 10px`,
                }}
                onChange={(e) => onChange(e)}
                value={formData?.floor_id}
              >
                <option value={null}>Select Floor</option>
                {floorList.map((item) => (
                  <option value={item.id}>{item.floor}</option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-4 col">
            <div className="mb-3">
              <h5 className="text-main fw-bold">Room</h5>
              <select
                name="room_id"
                id="room_id"
                className="form-select admin-list"
                style={{
                  background: `#272a3d url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='${
                    dark ? "white" : ""
                  }' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right .75rem center/8px 10px`,
                }}
                onChange={(e) => onChange(e)}
                value={formData.room_id}
              >
                <option value={null}>Select Room</option>
                {roomList?.map((room) => (
                  <option value={room.id}>{room.Room}</option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {client && building && floor && room && (
          <>
            <div className="row">
              <div className="col-lg-4 col">
                <div className="mb-3">
                  <h5 className="text-main fw-bold">Configurations</h5>
                  <div className="row mb-2">
                    <div className="col">Name</div>
                    <div className="col text-center">Min</div>
                    <div className="col text-center">Max</div>
                    <div className="col text-center d-flex gap-2 justify-content-center align-items-center">
                      <div>Activate</div>
                      <input
                        checked={isSelect}
                        type="checkbox"
                        name="activate-all"
                        id="activate-all"
                        onChange={onSelectDeselect}
                      />
                    </div>
                    <div className="col text-center">Action</div>
                  </div>
                  {formData.config && (
                    <>
                      {Object.keys(formData.config).map((key) => (
                        <div className="row mb-2">
                          <div className="col">
                            <TriggerDescTooltip
                              content={formData?.config[key].desc}
                            />
                            {key}
                          </div>
                          <div className="col">
                            <input
                              type="number"
                              className="form-control rounded admin-list text-main text-center"
                              id={key}
                              placeholder="Enter Value..."
                              required
                              value={formData.config[key].min}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  config: {
                                    ...formData.config,
                                    [key]: {
                                      ...formData.config[key],
                                      min: parseFloat(e.target.value),
                                    },
                                  },
                                });
                              }}
                            />
                          </div>
                          <div className="col">
                            <input
                              type="number"
                              className="form-control rounded admin-list text-main text-center"
                              placeholder="Enter Value..."
                              required
                              value={formData.config[key].max}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  config: {
                                    ...formData.config,
                                    [key]: {
                                      ...formData.config[key],
                                      max: parseFloat(e.target.value),
                                    },
                                  },
                                });
                              }}
                            />
                          </div>
                          <div className="col d-flex align-items-center justify-content-center">
                            <input
                              type="checkbox"
                              id="checkbox"
                              checked={formData.config[key].activate}
                              onChange={() => {
                                setFormData({
                                  ...formData,
                                  config: {
                                    ...formData.config,
                                    [key]: {
                                      ...formData.config[key],
                                      activate: !formData.config[key].activate,
                                    },
                                  },
                                });
                              }}
                            />
                          </div>
                          <div className="col d-flex align-items-center justify-content-center">
                            <div
                              className="btn admin-list-btn-secondary d-flex align-items-center px-3 text-main"
                              onClick={(e) => {
                                console.log(key);
                                setFormData({
                                  ...formData,
                                  config: {
                                    ...formData.config,
                                    [key]: {
                                      ...formData.config[key],
                                      min: configs.default_configs[key].min,
                                      max: configs.default_configs[key].max,
                                      activate:
                                        configs.default_configs[key].activate,
                                    },
                                  },
                                });
                              }}
                            >
                              Reset
                            </div>
                          </div>
                        </div>
                      ))}
                    </>
                  )}
                </div>
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-center gap-3">
              {!configs?.setNew ? (
                <>
                  {/* Reset button */}
                  <button
                    className="admin-list-btn-secondary text-main btn-block btn admin-list-btn px-5"
                    onClick={(e) => {
                      setFormData({
                        ...formData,
                        config: configs.default_configs,
                      });
                    }}
                  >
                    Reset All
                  </button>

                  {/* Save button */}
                  <button
                    type="submit"
                    disabled={
                      user.client_id === null
                        ? formData.client_id == 0 ||
                          formData.client_id === undefined
                        : false
                    }
                    className="admin-list-btn-secondary text-main btn-block admin-list-btn  btn px-5"
                  >
                    Save
                  </button>

                  {/* Delete button */}
                  {/* <button
                    className="btn-danger text-main btn-block admin-list-btn btn px-5"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-trash-fill button-child"
                      viewBox="0 0 16 16"
                    >
                      <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                    </svg>
                    Delete
                  </button> */}
                </>
              ) : (
                <button
                  type="submit"
                  disabled={
                    user.client_id === null
                      ? formData.client_id == 0 ||
                        formData.client_id === undefined
                      : false
                  }
                  className="admin-list-btn-secondary text-main btn-block admin-list-btn  btn px-5"
                >
                  Save
                </button>
              )}
            </div>
          </>
        )}
      </form>
    </div>
  );
};

export default ConfigsForm;
